import styled, { css } from 'styled-components'
import { tint } from 'polished'

import { ButtonUnstyled } from 'components/Button'
import { breakpoint } from 'utils'

export type BannerType = 'information' | 'warning' | 'error'

interface WrapperProps {
  $type: BannerType
}

export const CloseButton = styled(ButtonUnstyled)`
  margin-left: 8px;
  flex-shrink: 0;

  width: 24px;
  height: 24px;
`

export const IconWrapper = styled.div`
  width: 16px;
  height: 16px;
  margin: 4px 8px 4px 0px;
  line-height: 0;
  flex-shrink: 0;
`

export const Wrapper = styled.aside<WrapperProps>(
  ({ theme, $type }) => css`
    display: flex;
    min-height: 40px;

    padding: 8px 16px 8px 16px;
    border-radius: ${theme.radii.large};

    /* To affect both the icon and text */
    color: ${theme.colors.foreground.secondary[3]};

    ${() => {
      switch ($type) {
        case 'error': {
          return css`
            background-color: ${tint(0.9, theme.colors.state.negative)};

            ${CloseButton}, ${IconWrapper} {
              color: ${theme.colors.state.negative};
            }
          `
        }
        case 'warning': {
          return css`
            background-color: ${tint(0.9, theme.colors.state.warning)};

            ${CloseButton}, ${IconWrapper} {
              color: ${theme.colors.state.warning};
            }
          `
        }
        case 'information': {
          return css`
            border: 1px solid ${theme.colors.border[2]};
          `
        }
      }
    }}

    b {
      font-weight: ${theme.fontWeights.medium};
      color: ${theme.colors.foreground.secondary[1]};
    }
  `
)

export const Text = styled.span`
  width: 100%;

  font-size: ${({ theme }) => theme.fontSizes.smaller};
  font-weight: 400;
  line-height: 1.5;
  margin: 2px auto 2px 0; /* stylelint-disable-line scales/space */

  align-self: center;

  a:not([class]) {
    color: ${({ theme }) => theme.colors.foreground.secondary[1]};
    font-weight: ${({ theme }) => theme.fontWeights.semibold};
    text-decoration: underline;
  }
`

interface BannerPageWrapperProps {
  $hideMargins?: 'top' | 'bottom' | 'both'
}

export const BannerPageWrapper = styled.div<BannerPageWrapperProps>`
  display: flex;
  flex-direction: column;

  ${Wrapper} + ${Wrapper} {
    margin-top: 8px;
  }

  ${Wrapper} {
    :nth-child(1) {
      margin-top: 16px;
    }

    :nth-last-child(1) {
      margin-bottom: 16px;
    }

    ${breakpoint('sm')`${css`
      :nth-child(1) {
        margin-top: 40px;
      }

      :nth-last-child(1) {
        margin-bottom: 40px;
      }
    `}`}

    ${({ $hideMargins }) => {
      switch ($hideMargins) {
        case 'both':
          return css`
            :nth-child(1) {
              margin-top: 0;
            }

            :nth-last-child(1) {
              margin-bottom: 0;
            }
          `
        case 'top':
          return css`
            :nth-child(1) {
              margin-top: 0;
            }
          `
        case 'bottom':
          return css`
            :nth-last-child(1) {
              margin-bottom: 0;
            }
          `
      }
    }}
  }
`
